import React, { FC, useEffect, useState } from 'react';

import { Box, Stack, WrapItem, Wrap, HStack } from '@chakra-ui/react';
import { map, filter, includes } from 'lodash';
import { useSelector } from 'react-redux';

import { Tag } from 'components/DataDisplay';
import { Select } from 'components/DataEntry';

import { useEnvironmentContext } from '../../../../context';
import { selectEnvironment } from '../../../../selectors';

export const ResourceGroupCriteria: FC = () => {
  const { formData, resourceGroups } = useSelector(selectEnvironment);
  const { updateCriteria } = useEnvironmentContext();
  const { criteria } = formData;

  const [selectedResourceGroups, setSelectedResourceGroups] = useState<
    Record<string, any>[]
  >([]);
  const [resourceGroupOptions, setResourceGroupOptions] = useState<
    Record<string, any>[]
  >([]);

  useEffect(() => {
    setResourceGroupOptions(
      map(resourceGroups.data, o => ({ label: o, value: o })),
    );
  }, [resourceGroups]);

  useEffect(() => {
    setSelectedResourceGroups(
      filter(resourceGroupOptions, o =>
        includes(criteria?.resource_groups, o.value),
      ),
    );
  }, [resourceGroupOptions, criteria?.resource_groups]);

  return (
    <Stack>
      <HStack w="full">
        <Box whiteSpace="nowrap" pt={1}>
          If an entity is in resource group
        </Box>
        <Box minW={48}>
          <Select
            options={resourceGroupOptions}
            isMulti
            value={selectedResourceGroups}
            onChange={selected =>
              updateCriteria(
                'resource_groups',
                map(selected, o => o.value),
              )
            }
            showTotalSelected={!!selectedResourceGroups.length}
            isLoading={resourceGroups.isLoading}
          />
        </Box>
      </HStack>
      <Wrap>
        {map(criteria?.resource_groups, o => (
          <WrapItem>
            <Tag
              label={o}
              closeButton
              onClose={() =>
                updateCriteria(
                  'resource_groups',
                  filter(criteria?.resource_groups, l => l !== o),
                )
              }
            />
          </WrapItem>
        ))}
      </Wrap>
    </Stack>
  );
};
